import script from "./WebSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./WebSettings.vue?vue&type=script&setup=true&lang=js"

import "./WebSettings.vue?vue&type=style&index=0&id=2b894882&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b894882"]])

export default __exports__